module.exports = __webpack_public_path__ + "img/com.codeway.rockidentifier-staging.463a8977.png";